import * as Scrivito from "scrivito";

const IntroPageWidget = Scrivito.provideWidgetClass("IntroPageWidget", {
  attributes: {
    headline: "string",
    hint: "string",
    buttonText: "string",
  },
  onlyInside: ["FormWidget"],
});
export default IntroPageWidget;
